var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Export",
    transform: "translate(-23.000000, -12.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1250764,20.0600693 C39.2417927,20.1767252 39.3073684,20.3349809 39.3073684,20.5 C39.3073684,20.6650191 39.2417927,20.8232748 39.1250764,20.9399307 L36.4349716,23.6300356 C36.191912,23.8724619 35.7984268,23.8722053 35.5556836,23.6294622 C35.3129405,23.386719 35.3126839,22.9932338 35.5551102,22.7501742 L37.1829324,21.1222222 L31.6538962,21.1222222 C31.3102523,21.1222222 31.031674,20.8436438 31.031674,20.5 C31.031674,20.1563562 31.3102523,19.8777778 31.6538962,19.8777778 L37.1829324,19.8777778 L35.5551102,18.2498258 C35.3126839,18.0067662 35.3129405,17.613281 35.5556836,17.3705378 C35.7984268,17.1277947 36.191912,17.1275381 36.4349716,17.3699644 L39.1250764,20.0600693 Z M23.9295906,28.5 L32.9073681,28.5 C33.2509924,28.5 33.5295903,28.2214021 33.5295903,27.8777778 L33.5295903,24.8121529 C33.5295903,24.468509 33.2510119,24.1899307 32.9073681,24.1899307 C32.5637243,24.1899307 32.2851459,24.468509 32.2851459,24.8121529 L32.2851459,27.2555556 L24.5518128,27.2555556 L24.5518128,13.7444444 L32.2851459,13.7444444 L32.2851459,16.1878471 C32.2851459,16.531491 32.5637243,16.8100693 32.9073681,16.8100693 C33.2510119,16.8100693 33.5295903,16.531491 33.5295903,16.1878471 L33.5295903,13.1222222 C33.5295903,12.7785979 33.2509924,12.5 32.9073681,12.5 L23.9295906,12.5 C23.5859663,12.5 23.3073684,12.7785979 23.3073684,13.1222222 L23.3073684,27.8777778 C23.3073684,28.2214021 23.5859663,28.5 23.9295906,28.5 Z",
    id: "Shape",
    transform: "translate(31.307368, 20.500000) rotate(-90.000000) translate(-31.307368, -20.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrow);
export default __webpack_public_path__ + "static/media/box-arrow.055759d6d9c0a950c53b444cd4f4ed4e.svg";
export { ForwardRef as ReactComponent };